import React from 'react';
import PropTypes from 'prop-types';

import AttributesList from '../AttributesList';
import TrackControls from './TrackControls';
import LayerControl from '../../LayerControl';
import InterferometryChart from './InterferometryChart';

class Interferometry extends React.PureComponent {
	static propTypes = {
		feature: PropTypes.object,
	};

	render() {
		const props = this.props;

		return (
			<div className="eo4sdDrrInsarVietnam20-panel-section-content">
				<TrackControls />

				<div className="eo4sdDrrInsarVietnam20-interferometry-visualization-control">
					<span>Visualization</span>
					<LayerControl layerKey="interferometry-points-big" hideRemoval />
				</div>

				<div className="eo4sdDrrInsarVietnam20-panel-data-wrapper">
					{props.feature ? (
						<>
							<InterferometryChart attributes={this.props.feature.properties} />
							<AttributesList
								featureProperties={this.props.feature.properties}
							/>
						</>
					) : (
						<p className="centered">Select point...</p>
					)}
				</div>
			</div>
		);
	}
}

export default Interferometry;
